module.exports = __webpack_public_path__ + "img/add2.ea11fa75.png";